import { Table, TableBody, TableCell } from "@material-ui/core";
import { calculateQuarterly, calculateYearly, formatMoneyCents } from "../../helpers";
import { BlackCellBorderWhite, BlueCell, DarkBlueCell, DarkBlueCellBorder, DarkGreyCellBorder, LightBlueCellBorder, StyledTableRow } from "../Page/TableStyles";




export default function FutureBreakdownTable(props) {
    const {formData, estimatedDailyUsage,
        increasedDailyCharge, increasedDailyFIT,
        estimatedStorage, estimatedDailyExportAfterStorage } = props;



    return (
        <>
            <Table size='small'>
                <TableBody>
                    <StyledTableRow>
                        <BlueCell colSpan={2}>Your Estimated Energy Breakdown</BlueCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <DarkGreyCellBorder>Usage Breakdown</DarkGreyCellBorder>
                        <DarkGreyCellBorder>Total</DarkGreyCellBorder>
                        <DarkGreyCellBorder>Current KWH Rate</DarkGreyCellBorder>
                        <DarkGreyCellBorder>Daily Saving</DarkGreyCellBorder>
                        <DarkGreyCellBorder>Quarterly Saving</DarkGreyCellBorder>
                        <DarkGreyCellBorder>Annual Saving</DarkGreyCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BlackCellBorderWhite>Usage Savings</BlackCellBorderWhite>
                        <TableCell>{estimatedDailyUsage}</TableCell>
                        <TableCell>{formatMoneyCents(increasedDailyCharge)}</TableCell>
                        <TableCell>{formatMoneyCents(increasedDailyCharge * estimatedDailyUsage)}</TableCell>
                        <TableCell>{formatMoneyCents(calculateQuarterly(increasedDailyCharge * estimatedDailyUsage))}</TableCell>
                        <TableCell>{formatMoneyCents(calculateYearly(increasedDailyCharge * estimatedDailyUsage))}</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <DarkBlueCell>Storage Savings</DarkBlueCell>
                        <LightBlueCellBorder>{estimatedStorage}</LightBlueCellBorder>
                        <LightBlueCellBorder>{formatMoneyCents(increasedDailyCharge)}</LightBlueCellBorder>
                        <LightBlueCellBorder>{formatMoneyCents(increasedDailyCharge * estimatedStorage)}</LightBlueCellBorder>
                        <LightBlueCellBorder>{formatMoneyCents(calculateQuarterly(increasedDailyCharge * estimatedStorage))}</LightBlueCellBorder>
                        <LightBlueCellBorder>{formatMoneyCents(calculateYearly(increasedDailyCharge * estimatedStorage))}</LightBlueCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BlackCellBorderWhite>Export Savings (FIT)</BlackCellBorderWhite>
                        <TableCell>{estimatedDailyExportAfterStorage}</TableCell>
                        <TableCell>{formatMoneyCents(increasedDailyFIT)}</TableCell>
                        <TableCell>{formatMoneyCents(increasedDailyFIT * estimatedDailyExportAfterStorage)}</TableCell>
                        <TableCell>{formatMoneyCents(calculateQuarterly(increasedDailyFIT * estimatedDailyExportAfterStorage))}</TableCell>
                        <TableCell>{formatMoneyCents(calculateYearly(increasedDailyFIT * estimatedDailyExportAfterStorage))}</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell>&nbsp;</TableCell>
                        <TableCell>&nbsp;</TableCell>
                        <BlackCellBorderWhite>Total Savings</BlackCellBorderWhite>
                        <LightBlueCellBorder>{formatMoneyCents(((estimatedDailyUsage + estimatedStorage) * increasedDailyCharge) + (increasedDailyFIT * estimatedDailyExportAfterStorage))}</LightBlueCellBorder>
                        <DarkBlueCellBorder>{formatMoneyCents(calculateQuarterly(((estimatedDailyUsage + estimatedStorage) * increasedDailyCharge) + (increasedDailyFIT * estimatedDailyExportAfterStorage)))}</DarkBlueCellBorder>
                        <DarkBlueCellBorder>{formatMoneyCents(calculateYearly(((estimatedDailyUsage + estimatedStorage) * increasedDailyCharge) + (increasedDailyFIT * estimatedDailyExportAfterStorage)))}</DarkBlueCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell>&nbsp;</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell colSpan={3} style={{padding: 0, verticalAlign: "top"}}>
                            <div style={{maxWidth: '350px', border: '2px solid black', padding: '10px', textAlign: 'center', backgroundColor: '#9BC2E6'}}>
                                <span style={{display: 'flex', alignItems: 'center', height: '100%'}}>Estimated savings, Based on Estimated Increase next 12 Months</span>
                            </div>
                        </TableCell>
                        <TableCell colSpan={3} style={{padding: 0}}>
                            <Table size="small">
                                <TableBody>
                                    <StyledTableRow>
                                        <DarkBlueCellBorder colSpan={3} style={{textAlign: 'center', fontWeight: 'bold'}}>Estimated</DarkBlueCellBorder>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <BlackCellBorderWhite>5 Year</BlackCellBorderWhite>
                                        <BlackCellBorderWhite>10 Year</BlackCellBorderWhite>
                                        <BlackCellBorderWhite>25 Year</BlackCellBorderWhite>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 5)}</TableCell>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 10)}</TableCell>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 25)}</TableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: '30px'}}>

                <div>

                </div>
            </div>
        </>
    )
}